export default __webpack_public_path__ + "static/media/Matting_Category_banner_accessories.b364c41d.jpeg";